/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useState, useEffect } from "react";
import { Modal, Col, Row } from "react-bootstrap";
import { WebApi } from "../../api/web";
import { Errors } from "../../utilities/error";
import { Snackbar } from "../index";

const ModalGift = (props) => {
  const [tyepSends, setTypesend] = useState(null);
  const [typeSendId, setTypeSendId] = useState(null);
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [typePrice, setTypePrice] = useState(0);
  const [inputs, setInputs] = useState({
    mobile: null,
    city: null,
    province: null,
    postcode: null,
    address: null,
    email: null,
    count: 1,
  });
  const handleInputs = (e) => {
    if (e.target.files) {
      const name = e.target.name;
      const val = e.target.files[0];
      setInputs((prev) => {
        return {
          ...prev,
          [name]: val,
        };
      });
    } else {
      const name = e.target.name;
      const val = e.target.value;
      setInputs((prev) => {
        return {
          ...prev,
          [name]: val,
        };
      });
    }
  };
  useEffect(() => {
    Provinces();
    TypeSends();
  }, []);

  const TypeSends = async () => {
    await WebApi.sends()
      .then((res) => {
        setTypesend(res.data.data.sends);
      })
      .catch((err) => {});
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (props.isDownloadable) {
      if (inputs.email) {
        OrderGift();
      } else {
        Snackbar({
          message: "پر کردن فیلد ایمیل اجباری هست",
          type: "warning",
        });
      }
    } else {
      if (
        inputs.address &&
        inputs.mobile &&
        inputs.postcode &&
        inputs.province &&
        inputs.city &&
        inputs.count
      ) {
        OrderGift();
      } else {
        Snackbar({
          message: "کابر گرامی پر کردن تمامی فیلد هااجباری هست",
          type: "warning",
        });
      }
    }
    const OrderGift = async () => {
      await WebApi.orderGift(props.product._id, inputs, typeSendId)
        .then((res) => {
          window.location.href = res.data.data.orderGift.url;
        })
        .catch((err) => {
          Snackbar({
            title: "نا موفق",
            message: Errors[err.response.data.errors[0].message],
            type: "danger",
          });
        });
    };
  };
  const Provinces = async () => {
    await WebApi.provinces()
      .then((res) => {
        setProvinces(res.data.data.provinces);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    selectProvinces();
  }, [inputs.province]);

  const selectProvinces = async () => {
    await WebApi.cities(inputs.province)
      .then((res) => {
        setCities(res.data.data.cities);
      })
      .catch((err) => console.log(err));
  };
  const settingTypeSend = (value) => {
    setTypeSendId(value._id);
    if (props.product.finalPrice < value.free) {
      setTypePrice(value.price);
    }
  };
  return (
    <Modal
      {...props}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>
          <h5>
            اطلاعات زیر را مطابق با اطلاعاتی کاربری که میخواهید هدیه دهید پر
            کنید
          </h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          {props.product.isDownloadable ? (
            <Row>
              <Col md={12}>
                <div className='input-cart'>
                  <span>آدرس ایمیل</span>
                  <input
                    type='email'
                    name='email'
                    onChange={(e) => handleInputs(e)}
                  />
                </div>
              </Col>
            </Row>
          ) : (
            <>
              <Row>
                <Col md={6}>
                  <div className='input-cart'>
                    <span>موبایل</span>
                    <input
                      type='text'
                      name='mobile'
                      onChange={(e) => handleInputs(e)}
                    />
                  </div>
                </Col>
                <Col md={6}>
                  <div className='input-cart'>
                    <span>کد پستی</span>
                    <input
                      type='text'
                      name='postcode'
                      onChange={(e) => handleInputs(e)}
                    />
                  </div>
                </Col>
                <Col md={6}>
                  <div className='input-cart'>
                    <span>استان</span>
                    <select
                      type='text'
                      name='province'
                      onChange={(e) => handleInputs(e)}
                    >
                      <option value='' disabled selected></option>
                      {provinces.map((province) => (
                        <option value={province._id}>{province.title}</option>
                      ))}
                    </select>
                  </div>
                </Col>
                <Col md={6}>
                  <div className='input-cart'>
                    <span>شهر</span>
                    <select
                      type='text'
                      name='city'
                      onChange={(e) => handleInputs(e)}
                    >
                      <option value='' disabled selected></option>
                      {cities.map((city) => (
                        <option value={city._id}>{city.title}</option>
                      ))}
                    </select>
                  </div>
                </Col>
                <Col md={6}>
                  <div className='input-cart'>
                    <span>نشانی دقیق</span>
                    <input
                      type='text'
                      name='address'
                      onChange={(e) => handleInputs(e)}
                    />
                  </div>
                </Col>
                <Col md={6}>
                  <div className='input-cart'>
                    <span>تعداد</span>
                    <input
                      type='number'
                      value={inputs["count"]}
                      onChange={(e) => handleInputs(e)}
                      name='count'
                    />
                  </div>
                </Col>
              </Row>
              <div className='type-send'>
                <Row>
                  {tyepSends &&
                    tyepSends.map((tyepSend) => (
                      <Col md={4}>
                        <div
                          className={`item ${
                            tyepSend._id == typeSendId ? "active" : ""
                          }`}
                          onClick={() => settingTypeSend(tyepSend)}
                        >
                          <img src={tyepSend.icon} alt={tyepSend.title} />
                          <span>{tyepSend.title}</span>
                        </div>
                      </Col>
                    ))}
                </Row>
              </div>
            </>
          )}
          {/* <div className='box-price'>
            <span>{`${NumberWithCommas(
              props.product.finalPrice * inputs.count + typePrice
            )} تومان`}</span>
          </div> */}
          <button className='btn-click box-shadow'>
            فاکتور را پرداخت کنید
          </button>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default ModalGift;
